import { call, select } from 'typed-redux-saga/macro';

import getI13nUtils from 'Lib/i13n/getI13nUtils';
import requestIdleCallbackManager from 'Lib/requestIdleCallbackManager';

import SparksService from 'Store/sparks/SparksService';

const { executeEvent } = getI13nUtils();

export const loadSelectors = async () => {
  const { selectors } = await import(
    './sparks.selectors' /* webpackChunkName: "async-spark-selectors" */
  );
  return selectors;
};

// Connects SparkService with the store, passing along the payload for each event
export function* sparksSaga(action, defaultSelectors = {}) {
  const { payload = {} } = action;
  const {
    eventData: payloadEventData,
    eventType,
    options, // only used for enabling forceSend
  } = payload;

  const selectors = (yield* call(loadSelectors)) || defaultSelectors; // defaultSelectors just for unit test
  if (eventType in selectors) {
    const eventData = yield* select(selectors[eventType], payloadEventData);
    requestIdleCallbackManager.addTask(() => SparksService.track(eventData, options));
    // repeat it on the i13n bus for plugins
    executeEvent('sparksEvent', eventData);
  }
}
